const additionalSourcesSchema = {
  version: 1.00,
  name: 'Additional Sources',
  emissionSources: []
}

export default additionalSourcesSchema
